import * as React from 'react';

import { LayoutContext } from '../context/LayoutContext';
import { useWindowResizeEventListener } from './useWindowEventListener';

export const useHeaderHeight = (shouldCalculate: any) => {
  const { mobileHeaderRef, desktopHeaderRef } = React.useContext(LayoutContext);
  const [headerHeight, setHeaderHeight] = React.useState(161);

  const updateHeaderHeight = () => {
    if (
      shouldCalculate &&
      mobileHeaderRef &&
      // @ts-expect-error TS(2339): Property 'current' does not exist on type 'never'.
      mobileHeaderRef.current &&
      desktopHeaderRef &&
      // @ts-expect-error TS(2339): Property 'current' does not exist on type 'never'.
      desktopHeaderRef.current
    ) {
      setHeaderHeight(
        // @ts-expect-error TS(2339): Property 'current' does not exist on type 'never'.
        mobileHeaderRef.current.getBoundingClientRect().height +
          // @ts-expect-error TS(2339): Property 'current' does not exist on type 'never'.
          desktopHeaderRef.current.getBoundingClientRect().height +
          1,
      );
    }
  };

  React.useEffect(updateHeaderHeight, [
    shouldCalculate,
    mobileHeaderRef,
    desktopHeaderRef,
  ]);

  const handleResize = () => {
    setTimeout(() => {
      updateHeaderHeight();
    }, 0);
  };

  useWindowResizeEventListener(handleResize);

  return headerHeight;
};
